export default class TapArea extends Phaser.Sprite {
  constructor({ game, width, height, debug = false }) {
    super(game);

    this.inputEnabled = true;
    this.hitArea = new Phaser.Rectangle(0, 0, width || this.game.defaultWidth, height || this.game.defaultHeight);

    this.onSwipeLeft = new Phaser.Signal();
    this.onSwipeRight = new Phaser.Signal();
    this.onSwipeUp = new Phaser.Signal();

    if (debug) {
      this.debugGraphic = this.game.make.graphics();
      this.debugGraphic.beginFill(0xff0000, 0.25);
      this.debugGraphic.drawRect(0, 0, this.hitArea.width, this.hitArea.height);
      this.addChild(this.debugGraphic);
    }
  }

  activate() {
    this.events.onInputDown.add(this.handleDown, this);
  }

  deactivate() {
    this.events.onInputDown.remove(this.handleDown, this);
  }

  handleDown(e, b) {
    // swipe control
    // this.x0 = this.game.input.activePointer.x;
    // this.y0 = this.game.input.activePointer.y;
    //
    // this.game.time.events.add(100, this.tryAutoSwipe, this);
    // this.events.onInputUp.add(this.handleUp, this);

    // tap control
    let x0 = this.game.hero.worldPosition.x;
    let y0 = this.game.hero.worldPosition.y;
    let x1 = this.game.input.activePointer.x;
    let y1 = this.game.input.activePointer.y;
    const dx = x1 - x0;
    const dy = y1 - y0;
    if (Math.abs(dx) > Math.abs(dy) || dy > 0) {
      // horizontal move
      if (dx > 0) {
        this.onSwipeRight.dispatch();
      } else if (dx < 0) {
        this.onSwipeLeft.dispatch();
      }
    } else {
      this.onSwipeUp.dispatch();
    }
  }

  handleUp(e, b) {
    this.events.onInputUp.remove(this.handleUp, this);
    const dx = this.game.input.activePointer.x - this.x0;
    const dy = this.game.input.activePointer.y - this.y0;
    if (Math.abs(dx) > Math.abs(dy)) {
      // horizontal move
      if (dx > 0) {
        this.onSwipeRight.dispatch();
      } else if (dx < 0) {
        this.onSwipeLeft.dispatch();
      }
    } else if (dy < 0) {
      this.onSwipeUp.dispatch();
    }

    //this.onTap.dispatch({ taps_registered: this.tapsRegistered, x: x, y: y });
  }

  tryAutoSwipe() {
    const dx = this.game.input.activePointer.x - this.x0;
    const dy = this.game.input.activePointer.y - this.y0;

    if (Math.abs(dx) > 20 || Math.abs(dy) > 20) {
      this.handleUp();
    }
  }

  destroy() {
    this.deactivate();
    super.destroy(true);
  }
}
